import { render, staticRenderFns } from "./SomeCamMenu.vue?vue&type=template&id=2d0de492&scoped=true&"
import script from "./SomeCamMenu.vue?vue&type=script&lang=js&"
export * from "./SomeCamMenu.vue?vue&type=script&lang=js&"
import style0 from "./SomeCamMenu.vue?vue&type=style&index=0&id=2d0de492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0de492",
  null
  
)

export default component.exports